import { cva } from '@/styled-system/css';

export const skeletonBlock = cva({
  base: {
    display: 'block',
    backgroundColor: 'bg.softer',
  },
  variants: {
    // A variant, not a consumer override: two radius atomics on one element
    // leave the winner to Panda's utilities.css emission order, not cx order.
    radius: {
      sm: { borderRadius: 'sm' },
      md: { borderRadius: 'md' },
    },
    // Holds the place of a word inside a sentence.
    inline: {
      true: { display: 'inline-block', verticalAlign: 'middle' },
    },
  },
  defaultVariants: {
    radius: 'sm',
  },
});
